"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2022 - 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselDashboard = void 0;
const material_1 = require("@mui/material");
const React = require("react");
const react_router_1 = require("react-router");
const api_1 = require("../../api");
const useVessel_1 = require("../ui/useVessel");
const VesselDashboard = () => {
    const vessel = (0, useVessel_1.useVessel)(api_1.loadVesselDashboardQuery);
    const { embedKey } = (0, react_router_1.useParams)();
    if (!vessel) {
        return React.createElement(material_1.CircularProgress, null);
    }
    const embed = vessel.embeds[embedKey ? parseInt(embedKey, 10) : 0];
    return React.createElement(React.Fragment, null, embed ? React.createElement("iframe", { key: embed.ui.url, src: embed.ui.url, 
        //width={embed.width}
        width: "100%", height: embed.height, style: { border: "none" } }) : React.createElement(React.Fragment, null));
};
exports.VesselDashboard = VesselDashboard;
